import React from 'react';
import { ContainerBGStyleListTypes, TextComponentLayout } from '../../utils/utils';
import TextComponent from '../TextComponent/textComponent';
import BecomeAPartnerForm from './BecomeAPartnerForm/becomeAPartnerForm';
import './becomeAPartnerContainer.scss';

const BecomeAPartnerContainer = () => {
  return (
    <div className={`container-bg ${ContainerBGStyleListTypes.DARK} become-a-partner-container`}>
      <div className="container partner-content-wrapper">
        <div className="text-wrapper">
          <TextComponent
            layoutStyle={TextComponentLayout.LEFT}
            heading="Become a Paw-tner"
            description="If you feel like you would be a great addition to the TurfMutt team or have an idea about how we can continue to grow we would love to hear from you. "
          />
        </div>
        <div className="form-wrapper">
          <BecomeAPartnerForm />
        </div>
      </div>
    </div>
  );
};

export default BecomeAPartnerContainer;
